// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__Evqn5","vLegacy":"SelectSecondary_vLegacy__Sac1h","error":"SelectSecondary_error__-xPJq","disabled":"SelectSecondary_disabled__185rH"};